import React, { Dispatch, SetStateAction } from "react"

import { Container } from "./RadioButton.styled"

type Props = {
  name: string
  label: string | React.ReactNode
  id: string
  checked: boolean
  disabled?: boolean
  onChange: Dispatch<SetStateAction<boolean>>
}

export const RadioButton = ({ name, label, id, checked, onChange, disabled = false }: Props) => {
  const handleOnChange = () => {
    onChange(!checked)
  }

  return (
    <Container $checked={checked} onClick={handleOnChange}>
      <input type="radio" name={name} id={id} checked={checked} readOnly disabled={disabled} /> {label}
    </Container>
  )
}
